import { ErrorBoundary } from "react-error-boundary";

const logError = (error:Error, info: {componentStack: string}) => {
    // console.log('Her kommer error', error);
    // console.log('her kommer info', info);
    // Kan brukes til å logge error til DB eller annet
}

export const ErrorFallback: React.FC = ({children}) => {
    return (
        <ErrorBoundary fallbackRender={({error}) => (
            <div>Noe gikk galt: {error.message}</div>
        )} onError={logError}>
            {children}
        </ErrorBoundary>
    );
}